import Vue from 'vue';
import ediOrderTransformer from './../../transformers/ediOrder';
import store from './../../store';

const success = ({ data }, resolve) => {
  store.dispatch('fetchCurrentEdiOrder', ediOrderTransformer.fetch(data));
  resolve(ediOrderTransformer.fetch(data));
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/edi_orders/${id}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/show.js